import { render, staticRenderFns } from "./watermark.vue?vue&type=template&id=4793ddd7&scoped=true&"
import script from "./watermark.vue?vue&type=script&lang=js&"
export * from "./watermark.vue?vue&type=script&lang=js&"
import style0 from "./watermark.vue?vue&type=style&index=0&id=4793ddd7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793ddd7",
  null
  
)

export default component.exports